import { useEffect } from 'react'
import { useBienContext } from '../BienContext'
import Mandat from '../mandat'
import Info from '../info_bien'
import EspacesAnnexes from '../espaces_annexes'
import Surfaces from '../surfaces'
import Equipements from '../equipements'
import Structure from '../structure'
import Diagnostics from '../diagnostics'
import Energie from '../energie'
import InfoDiverses from '../info_diverses'

const InfoGenerales = () => {
  const { bien } = useBienContext()
  
  return (<div>
    <div className="p-4">
      <div id='mandat'>
        <Mandat.Detail />
      </div>
      <div id='info'>
        <Info.Detail/>
      </div>
      { bien.type_bien !== 'immeuble' && (
        <div id='espaces_annexes'>
          <EspacesAnnexes.Detail/>
        </div>
      )}
      <div id='surfaces'>
        <Surfaces.Detail/>
      </div>
      <div id='equipements'>
        <Equipements.Detail/>
      </div>
      <div id='structure'>
        <Structure.Detail/>
      </div>
      <div id='diagnostics'>
        <Diagnostics.Detail/>
      </div>
      <div id='energie' className='pb-[60px]'>
        <Energie.Detail/>
      </div>
      { bien.type_bien === 'immeuble' && (
        <InfoDiverses.Detail/>
      )}
      <div id='mandat_history'>
        <Mandat.HistoryList />
      </div>
    </div>
  </div>
)
}

export default InfoGenerales